const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20movie%20set%20with%20director%20and%20crew%2C%20camera%20equipment%2C%20warm%20cinematic%20lighting%2C%20professional%20film%20production%20atmosphere%2C%20soft%20golden%20hour%20glow%2C%20editorial%20photography%2C%20intimate%20candid%20moment&width=800&height=560&seq=cards-01&orientation=landscape',
    tag: '幕后揭秘',
    title: '《星际迷航》重启版片场直击：诺兰式实拍震撼幕后',
    desc: '独家探班揭秘导演如何用IMAX摄影机在零重力环境下完成史诗级太空长镜头。',
    date: '2小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Movie%20premiere%20red%20carpet%20event%20with%20celebrities%2C%20elegant%20evening%20gowns%2C%20flashing%20cameras%2C%20luxurious%20theater%20entrance%2C%20glamorous%20Hollywood%20atmosphere%2C%20warm%20golden%20lights%2C%20editorial%20fashion%20photography&width=800&height=560&seq=cards-02&orientation=landscape',
    tag: '明星动态',
    title: '暑期档票房大战：周迅新片首日破3亿创国产文艺片纪录',
    desc: '低调文艺片意外击败多部商业大片登顶日冠，院线紧急追加排片场次。',
    date: '5小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20arguing%20at%20press%20conference%2C%20dramatic%20tension%2C%20microphones%2C%20intense%20atmosphere%2C%20journalists%20surrounding%2C%20cinematic%20lighting%2C%20documentary%20style%20photography%2C%20high%20contrast&width=800&height=560&seq=cards-03&orientation=landscape',
    tag: '争议事件',
    title: '张艺谋新片陷"抄袭门"？编剧圈联名声讨制作方回应',
    desc: '知名编剧发万字长文指控核心设定雷同，制作方凌晨紧急发布声明。',
    date: '8小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Movie%20box%20office%20chart%20dashboard%20with%20golden%20numbers%2C%20luxurious%20dark%20cinema%20aesthetic%2C%20statistics%20display%2C%20warm%20spotlight%20effect%2C%20elegant%20corporate%20style%2C%20high%20end%20visual%20design&width=800&height=560&seq=cards-04&orientation=landscape',
    tag: '票房黑马',
    title: '小成本惊悚片逆袭：300万成本博得12亿全球票房',
    desc: '无明星无IP全靠口碑发酵，这部马来西亚华语片如何成为年度最大黑马。',
    date: '12小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Two%20celebrities%20in%20intimate%20restaurant%20setting%2C%20candlelit%20dinner%2C%20paparazzi%20style%20photography%2C%20secretive%20atmosphere%2C%20warm%20dim%20lighting%2C%20exclusive%20scoop%2C%20cinematic%20noir%20aesthetic&width=800&height=560&seq=cards-05&orientation=landscape',
    tag: '八卦揭秘',
    title: '独家：顶流男星深夜密会圈外女友，恋情曝光细节全记录',
    desc: '跟拍三个月独家镜头还原恋情始末，经纪人沉默以对引更多猜测。',
    date: '1天前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Film%20festival%20jury%20panel%20discussion%2C%20prestigious%20award%20ceremony%2C%20golden%20trophies%2C%20elegant%20stage%20design%2C%20warm%20theater%20lighting%2C%20sophisticated%20cultural%20event%2C%20editorial%20photography&width=800&height=560&seq=cards-06&orientation=landscape',
    tag: '电影评分',
    title: '戛纳电影节华语片全军覆没？评委内部分歧曝光',
    desc: '内部人士透露评审过程激烈争论，某华语片距入围仅差一票引遗憾。',
    date: '2天前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Movie%20streaming%20platform%20interface%20on%20large%20screen%2C%20modern%20living%20room%2C%20cozy%20atmosphere%2C%20content%20recommendation%2C%20digital%20entertainment%2C%20warm%20ambient%20lighting%2C%20lifestyle%20photography&width=800&height=560&seq=cards-07&orientation=landscape',
    tag: '独家追踪',
    title: 'Netflix华语内容大撤退背后：流媒体亚洲战略全面调整',
    desc: '从重金投入到大面积砍项目，三年烧掉20亿美元后的战略急转弯。',
    date: '3天前',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-4">
            独家揭秘专题
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-[560px] mx-auto">
            深入电影幕后，追踪明星动态，揭晓你最想知道的影视圈内幕
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
            {cards.map((card, i) => (
              <article
                key={i}
                className={`group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                  i === 0 ? 'sm:col-span-2 lg:col-span-2 xl:col-span-2' : ''
                }`}
              >
                <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[16/9]' : 'aspect-[4/3]'}`}>
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading={i > 3 ? 'lazy' : undefined}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-3 py-1 rounded-full bg-primary-500 text-white text-xs font-semibold">
                      {card.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                    {card.desc}
                  </p>
                  <span className="text-xs text-foreground-400">{card.date}</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}